export const MAX_STREAK = 7;
